<!--
  관리자 설정
  관리자/그룹 편집, 관리자 IP 설정 > 관리자 IP 추가 팝업

  @since 2020-02-14
  @author: mk.ko
-->

<template>
    <div>
      <layout-popup ref="groupIpAddLayerPopUp"
                    :isOpen.sync="isOpen"
                    :titleName="getTitle"
                    :confirmEvt="onConfirm"
                    :cancelEvt="onCancel"
                    :footerBtn="['confirm', 'cancel']"
                    :content-css="getContentCss"
                    @show="showAfter"
      >
        <!-- 기본 정보 -->
        <div class="content-group">
          <div class="contents-row">
            <div class="page-title-2depth">
              <span class="page-title-2depth-text">{{$t('sm.adminIpSettings_popup_defaultInfo')}}</span>
            </div>
            <!-- 컨텐츠 패널 시작 -->
            <div class="portlet">

              <div class="contents-row">

                <!-- 테이블 시작 -->
                <table class="bs-table table-bordered-none">
                  <colgroup>
                    <col width="25%"/>
                    <col width="auto"/>
                  </colgroup>
                  <tbody>
                    <tr>
                      <td class="td-head">{{$t('sm.adminIpSettings_popup_selectGroup')}}</td>
                      <td>
                        <div class="inline-group">
                          <q-input v-model="adminGeneral.admin_name" class="bs bs-q-input bs-q-input-default" style="width:270px;" disable/>
                        </div>
                      </td>
                    </tr>

                    <!-- IP 추가 영역 -->
                    <template v-if="!isDeleteView">

                      <tr>
                        <td class="td-head">{{$t('sm.adminIpSettings_popup_addIP')}} <span class="textR">*</span></td>
                        <td>
                          <div class="inline-group">
                            <ip-toggle v-if="ccFlag === 1"
                                      ref="ipToggle"
                                      name="ipToggle"
                                      v-model="ipType"
                                      :required="true"
                                      :ipv4-value="1"
                                      :ipv6-value="2"
                                      :ip.sync="admin_ip_exp"
                                      class="bs bs-q-ip-input bs-q-ip-input-default bs-q-ip-input-toggle"
                                      style="width: 100%"
                                      :validator="$validator">
                            </ip-toggle>
                            <ip-toggle v-if="ccFlag !== 1"
                                       ref="ipToggle"
                                       name="ipToggle"
                                       v-model="ipType"
                                       :required="true"
                                       :ipv4-value="1"
                                       :ipv6-value="2"
                                       :ip.sync="admin_ip_exp"
                                       :mask.sync="ip_exp_prefix"
                                       :ipv4MaskMaxValue="32"
                                       :ipv4MaskMinValue="1"
                                       :prefix-min="1"
                                       :prefix-max="128"
                                       class="bs bs-q-ip-input bs-q-ip-input-default bs-q-ip-input-toggle"
                                       style="width: 100%"
                                       :validator="$validator">
                            </ip-toggle>
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <td class="td-head">{{$t('sm.adminIpSettings_page_allowMac')}}</td>
                        <td>
                          <mac ref="mac" name="mac"
                               :mac.sync="admin_ip_mac"
                               :validator="$validator"
                          ></mac>
                        </td>
                      </tr>

                      <tr>
                        <td class="td-head">{{$t('cmn.description')}}</td>
                        <td>
                          <div class="inline-group">
                            <q-input v-model="admin_ip_desc" class="bs bs-q-input bs-q-input-default" style="width:270px;"/>
                          </div>
                        </td>
                      </tr>

                    </template>

                    <template v-if="isDeleteView">
                      <tr>
                        <td class="td-head">{{$t('sm.adminIpSettings_popup_deleteIP')}} <span class="textR">*</span></td>
                        <td>
                          <div class="inline-group">
                            <q-input class="bs bs-spinner bs-spinner-default" style="width:270px;"
                                     v-model="inSearchGroupIP"
                                     readonly
                                     disable
                                     name="adminip"
                                     :error="errors.has('adminip')"
                                     v-validate="'required'">
                              <tool-tip :message="$t('msg.selectAdminIpDeleteTableBelow')"></tool-tip>
                            </q-input>
                            <q-btn color="primary" size="sm" round class="bs bs-q-btn-sm bs-q-btn-page-title" style="margin-top: 1px;">
                              <span class="page-title-1depth-img"></span>
                              <q-tooltip anchor="bottom middle" self="top left" :offset="[10, 10]"
                                         class="bs bs-q-tooltip bs-q-tooltip-default">
                                <div class="bs-q-tooltip-contents">
                                  {{ $t('msg.selectAdminIpDeleteTableBelow') }}
                                </div>
                              </q-tooltip>
                            </q-btn>
                          </div>
                        </td>
                      </tr>
                    </template>

                  </tbody>
                </table>
                <!-- 테이블 끝 -->

              </div>

            </div>
            <!-- 컨텐츠 패널 끝 -->
          </div>
        </div>

        <template v-if="!isDeleteView">

          <div class="contents-clearfix-fold" />

          <div class="contents-row">
            <div class="portlet-fold">
              <q-btn color="dark"
                     flat="flat"
                     @click="btnShow"
                     class="bs bs-q-btn-xs bs-q-btn-flat-type bs-q-btn-portlet-fold portlet-fold-btn">
                <q-icon v-show="isBtnShow === true"
                        class="bs-q-btn-icon bs-q-btn-icon-portlet-fold-open"></q-icon>
                <q-icon v-show="isBtnShow === false"
                        class="bs-q-btn-icon bs-q-btn-icon-portlet-fold-close"></q-icon>
                <tool-tip :message="$t('sm.viewRegAdminIp')"></tool-tip>
              </q-btn>
            </div>
          </div>

        </template>

        <template v-else>
          <div class="contents-clearfix" />
        </template>

<!--        <div class="content-group">-->
        <div class="contents-row" v-show="isBtnShow">
          <div class="page-title-2depth">
            <span class="page-title-2depth-text">{{$t('sm.administrator_popup_adminIpList')}} <span v-if="!isDeleteView">({{$t('cmn.reference')}})</span></span>
          </div>

          <div class="portlet">
            <div class="contents-row">

              <!-- 테이블 시작 -->
              <table class="bs-table table-bordered-none">
                <colgroup>
                  <col width="50%"/>
                  <col width="50%"/>
                </colgroup>
                <tbody>

                  <tr>
                    <td class="td-head padR5">
                      <div class="inline-group">
                        <div class="page-title-1depth">
                          <span class="page-title-1depth-text" style="font-size: 13px;">{{$t('sm.adminIpSettings_popup_registedAdminIP')}}</span>
  <!--                         color:#014897;-->
                        </div>
                        <div class="page-contents-option-group option-group-sm">
                          <!-- 상위 버튼그룹 시작 -->
                          <div class="page-contents-btn-group-last">
                            <q-search v-model="searchIp" class="bs bs-q-sm bs-q-search bs-q-search-default"
                                      @keyup="onSearchClear">
                              <q-autocomplete separator @search="onSearch"/>
                            </q-search>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td class="padL5">
                      <div class="inline-group">
                        <!-- 타이틀 시작 -->
                        <div class="page-title-1depth">
                          <span class="page-title-1depth-text" style="font-size: 13px;">{{$t('sm.adminIpSettings_popup_usedAdminGroup')}}</span>
                        </div>
                        <!-- 타이틀 끝 -->
                        <!-- 상위 옵션 시작 -->
<!--                        <div class="page-contents-option-group option-group-sm">-->
<!--                          &lt;!&ndash; 상위 버튼그룹 시작 &ndash;&gt;-->
<!--                          <div class="page-contents-btn-group-last">-->
<!--                            <q-search ref="searchPoint" v-model="inSearchGroupIP" class="bs bs-q-sm bs-q-search bs-q-search-default"-->
<!--                                      @keyup="onGroupIpSearchClear">-->
<!--                              <q-autocomplete separator @search="onGroupIpSearch"/>-->
<!--                            </q-search>-->
<!--                          </div>-->
<!--                          &lt;!&ndash; 상위 버튼그룹 끝 &ndash;&gt;-->
<!--                        </div>-->
                        <!-- 상위 옵션 끝 -->
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td class="padR5">
                      <div class="contents-row">
                        <data-table ref="rdataTable"
                                    :fields="fields2"
                                    :data="adminIPData"
                                    height="464px"
                                    :virtualScrolling="true"
                                    :paging="false"
                                    :fieldSortable="false"
                                    :rowClicked="onRowClick"
                                    class="bs bs-data-table bs-data-table-basic"
                        ></data-table>
                      </div>
                    </td>
                    <td class="padL5">
                      <div class="contents-row ps-q-treeBlock">

                        <q-scroll-area  ref="scroll" style="height: 460px;">
                          <q-tree ref="treePop"
                                  :nodes="adminGroupTreeNodes"
                                  node-key="admin_id"
                                  :selected.sync="selected"
                                  :tick-strategy="tickStrategy"
                                  :dark="dark"
                                  :expanded.sync="expanded"
                                  :ticked.sync="ticked"
                                  :tickable="false"
                                  class="ps-q-tree ps-q-tree-square"
                                >
                            <div slot="header-custom" slot-scope="prop" class="row items-center">
                              <div>
                                {{prop.node.label}}
                              </div>
                            </div>
                          </q-tree>
                        </q-scroll-area>

                      </div>
                    </td>
                  </tr>

                </tbody>
              </table>
              </div>
  <!--        </div>-->
            </div>

        </div>

      </layout-popup>

    </div>
</template>

<script>
  import LayoutModalPopUp from '~/components/popUp/LayoutModalPopUp'
  import IpToggle from '~/components/control/ipForm/IpToggle'
  import Mac from '~/components/control/ipForm/Mac'

  import SplitterPanel from '~/components/layout/splitterPanel/SplitterPanel'

  import { createNamespacedHelpers } from 'vuex'

  const storeAdminGroupSettings = createNamespacedHelpers('system/adminSettings/adminGroupSettings')
  const storeAdministrator = createNamespacedHelpers('system/adminSettings/prism/administrator')
  const storeCommon = createNamespacedHelpers('common/common')

  import {fnIsBlank, fnConfirm, adminDataTreeConvert} from '~/utils/admin-common'

  export default {
    name: 'IpAddPopup',
    props: {
      isDeleteView: {
        type: Boolean,
        default: false
      }
    },
    components: {
      'layout-popup': LayoutModalPopUp,
      IpToggle,
      SplitterPanel,
      Mac
    },
    data () {
      return {
        showDialog2: null,
        isOpen: false,
        inSearchGroupIP: '',
        searchIp: null,
        datatable: [],
        tickStrategy: 'strict',
        ticked: [],
        filter: '',
        selected: null,
        dark: false,
        // 전체 아이피
        adminIPData: [],
        // 하위 그룹 자동적용
        // childAutoSet: false, #31418 - [System - 관리자 IP 설정] 관리자 IP 주소 추가 팝업 하위그룹 자동 적용 ON/OFF 버튼 제거
        admin_ip_exp: '',
        admin_ip_mac: '',
        admin_ip_desc: '',
        adminIpItem: {},
        ipType: 1,
        ip_exp_prefix: 32,
        adminGroupTreeNodes: [],
        expanded: [],
        isBtnShow: true
      }
    },
    created () {
      // this.$nextTick(() => {
      //   this.acsManagersIpAll()
      // })
    },
    computed: {
      ...storeAdministrator.mapState([
        'orgAdminGroupData'
      ]),
      ...storeAdminGroupSettings.mapState([
        'adminIpAll',
        'adminGeneral',
        'yourIpGroup',
        // 아이피 추가 상태
        'PostManagersIpNewResult',
        // 삭제 상태
        'DelManagersIpSecResult',
        // 등록/삭제/수정 에러
        'errorMessage'
      ]),
      ...storeCommon.mapState({
        ccFlag: state => state.uiData.system.cc_flag
        // ccFlag: () => 0
      }),
      getTitle () {
        if (this.isDeleteView) {
          return this.$t('sm.adminIpSettings_popup_delTitle')
        } else {
          return this.$t('sm.adminIpSettings_popup_addTitle')
        }
      },
      fields2 () {
        return [
          {
            name: 'admin_ip_exp',
            title: this.$t('cmn.ip'),
            width: 240,
            align: 'left',
            itemTemplate (value, row) {
              if (row.admin_ip_mac) {
                return `${value} [${row.admin_ip_mac}]`
              } else {
                return value
              }
            }
          },
          {name: 'admin_ip_desc', title: this.$t('cmn.description'), align: 'left', width: 170}
        ]
      },
      getContentCss () {
        if (this.isBtnShow) {
          return { width: '904px', minHeight: '750px' }
        } else {
          return { width: '904px', minHeight: '328px' }
        }
      }
    },
    methods: {
      ...storeAdminGroupSettings.mapActions([
        'acsAdminIpCurrConcat',
        'acsManagersGroup',
        'acsManagersIpAll',
        'acsManagersIpSec',
        'acsPostManagersIpNew',
        'acsDelManagersIpSec',
        'acsSetErrorMessage'
      ]),
      async show () {
        await this.acsManagersIpAll() // 좌측 테이블 전체 조회
        const org = this.orgAdminGroupData
        const min = org.reduce((p, c) => {
          return p.admin_id > c.admin_id ? c : p
        })
        this.adminGroupTreeNodes = adminDataTreeConvert(org, min.admin_id, { tickable: false }) // Read-Only
        this.expanded = org.map((item) => {
          return item.admin_id
        })
        this.isBtnShow = this.isDeleteView
        this.$nextTick(() => {
          this.$refs.groupIpAddLayerPopUp.show()
        })
      },
      showAfter () {
        this.popupInit()
        this.$nextTick(() => {
          this.$refs.rdataTable.render()
        })
        this.onSearchClear()
        this.$validator.reset()
      },
      // 아이피 목록 선택
      async onRowClick (v) {
        this.inSearchGroupIP = v.item.admin_ip_exp
        this.adminIpItem = v.item
        // 사용중인 관리그룹 체크
        await this.acsManagersIpSec({ip: this.inSearchGroupIP})
      },
      delIpdata () {
        if (fnIsBlank(this.inSearchGroupIP)) {
          this.acsSetErrorMessage(this.$t('msg.selectIpForDelete'))
          return false
        }
        const payload = {
          admin_id: this.adminGeneral.admin_id,
          ip: this.inSearchGroupIP
        }
        const delId = this.yourIpGroup.filter(item => {
          return item.admin_id !== this.adminGeneral.admin_id
        })
        // 다른 구룹에 아이피가 존재 할경우..
        if (delId.length > 0) {
          fnConfirm(this, this.$t('msg.usedDifferentGroup'), () => {
            this.acsDelManagersIpSec(payload)
          })
        } else if (delId.length === 0) {
          // 본인그룹에만 존재할경우 바로 삭제
          this.acsDelManagersIpSec(payload)
        }
      },
      setIpData () {
        const obj = {}
        obj.admin_id = this.adminGeneral.admin_id
        // obj.admin_ip_child_yn = this.childAutoSet ? 1 : 0 #31418 - [System - 관리자 IP 설정] 관리자 IP 주소 추가 팝업 하위그룹 자동 적용 ON/OFF 버튼 제거
        if (!fnIsBlank(this.admin_ip_exp)) {
          // 수동아이피 추가
          // obj.admin_ip_exp = (this.ip_exp_prefix === '' || this.ip_exp_prefix === 0 || this.ccFlag !== 1) ? this.admin_ip_exp : this.admin_ip_exp + '/' + this.ip_exp_prefix
          const fixedIp = (this.ipType === 1) ? this.admin_ip_exp + '/32' : this.admin_ip_exp + '/128' // Ipv4 는 netMask 32 고정, Ipv6 는 netMask 128 고정
          obj.admin_ip_exp = (this.ccFlag !== 1) ? this.admin_ip_exp + '/' + this.ip_exp_prefix : fixedIp // ccFlag 1 일 때는 netMask 를 숨키고 fixedIp 값을 사용하여, netMask 고정 값을 추가한다.
          obj.admin_ip_mac = this.admin_ip_mac
          obj.admin_ip_desc = this.admin_ip_desc
        } else {
          // 선택한 아이피
          obj.admin_ip_exp = this.adminIpItem.admin_ip_exp
          obj.admin_ip_desc = this.adminIpItem.admin_ip_desc
        }
        this.acsPostManagersIpNew(obj)
      },
      popupInit () {
        this.ticked = []
        // this.childAutoSet = false #31418 - [System - 관리자 IP 설정] 관리자 IP 주소 추가 팝업 하위그룹 자동 적용 ON/OFF 버튼 제거
        this.searchIp = null
        this.inSearchGroupIP = ''
        this.adminIpItem = {}
        this.admin_ip_exp = null
        this.admin_ip_mac = null
        this.admin_ip_desc = ''
        this.ipType = 1
        this.ip_exp_prefix = 32
      },
      async validate () {
        await this.$validator.validateAll()
        if (this.$validator.errors.count() === 0) {
          if (this.ccFlag === 1) {
            const validateOk = this.ipType === 1
              ? (this.admin_ip_exp.split('.').pop() !== '0') : (this.admin_ip_exp.split(':').pop().replaceAll('0', '') !== '')

            if (!validateOk) {
              this.$validatePopUp.show(this.$t('msg.onlyHostIpAvailable'))
              return false
            }
          }
          return true
        }

        this.$validatePopUp.show(this.$validator.errors.items)
        return false
      },
      // 관리자 아이피 팝업 확인
      async onConfirm () {
        if (this.isDeleteView) {
          // 삭제시
          this.delIpdata()
        } else {
          // 추가시
          let result = await this.validate()
          if (result) {
            if (this.admin_ip_mac && this.ip_exp_prefix !== (this.ipType === 1 ? 32 : 128)) {
              this.$alertPopUp.show(this.$t(`msg.adminIpMacPrefixMismatchv${this.ipType === 1 ? 4 : 6}`))
              return false
            }
            this.setIpData()
          }
        }
        this.datatable = []
      },
      onCancel () {},
      onSearchClear () {
        this.adminIPData = this.adminIpAll
      },
      // 사용중인 관리그룹
      async onGroupIpSearch (term, done) {
        if (term !== '') {
          this.inSearchGroupIP = term
          // 사용중인 관리그룹 체크
          await this.acsManagersIpSec({ip: this.inSearchGroupIP})
          done('', term)
        }
      },
      async onGroupIpSearchClear () {
        if (this.inSearchGroupIP === '') {
          await this.acsManagersIpSec({ip: ''})
        }
      },
      // 등록된전체 ip 검색`
      onSearch (term, done) {
        if (term !== '') {
          const searchText = term.toLowerCase()
          this.adminIPData = this.adminIpAll.filter(item => {
            return item.admin_ip_exp.toLowerCase().indexOf(searchText) > -1 || item.admin_ip_desc.toLowerCase().indexOf(searchText) > -1
          })
        }
        done('', term)
      },
      btnShow () {
        this.isBtnShow = !this.isBtnShow
        // this.$emit('filterShow', this.isBtnShow)
      }
    },
    watch: {
      // 관리자별 아이피 추가 상태
      async PostManagersIpNewResult (v) {
        if (typeof v === 'undefined' || v === null) {
          return
        }
        this.acsManagersIpAll() // 좌측 테이블 전체 조회
        const result = await this.acsManagersGroup(this.adminGeneral.admin_id) // 우측 개별 테이블 조회
        if (result !== 'ok') {
          this.$alertPopUp.show(result.errors)
          return
        }
        this.$refs.groupIpAddLayerPopUp.hide()
      },
      // 삭제
      async DelManagersIpSecResult (v) {
        if (typeof v === 'undefined' || v === null) {
          return
        }
        this.acsManagersIpAll()
        const result = await this.acsManagersGroup(this.adminGeneral.admin_id)
        if (result !== 'ok') {
          this.$alertPopUp.show(result.errors)
          return
        }
        this.$refs.groupIpAddLayerPopUp.hide()
      },
      // ticked
      yourIpGroup (val) {
        this.ticked = val
        // this.$nextTick(() => {
        //   this.$refs.searchPoint.focus()
        // })
      },
      // 전체아이피
      adminIpAll (val) {
        this.adminIPData = val
      },
      isBtnShow (value, prev) {
        if (value && !prev) {
          this.$nextTick(() => {
            this.$refs.rdataTable.render()
          })
        }
      }
    }
  }
</script>

<style scoped>
  .contents-clearfix-fold {
    position: relative;
    width: 100%;
    height: 20px;
    display: inline-block;
    font-size: 0;
    height: 11px !important;
  }
</style>
